import { combineReducers } from "redux";
import forwardEvaluationReducer from "./forwardEvaluation";
import getCvOfCampaignReducer from "./getCvofCampaign";
import getListReducer from "./getList";
import getInfoSelectedCandidateReducer from "./getInfoSelectedCandidate";
import getDetailCampaignReducer from "./getDetailCampaign";
import evaluateCVReducer from "../saga/evaluateCV";
import getDetailEvaluationReducer from "./getDetailEvaluation";
import filterEventsReducer from "./filterEvent";
import formDetailInterviewReducer from "./formDetailInterview";
import getDetailInterviewReducer from "./getDetailInterview";
import confirmParticipateReducer from "./confirmParticipate";
import updateResultPanelReducer from "./updateResultPanel";
import getListProgramReducer from "./getListProgram";

const recruitmentReducer = combineReducers({
  forwardEvaluationReducer,
  getListReducer,
  getCvOfCampaignReducer,
  getInfoSelectedCandidateReducer,
  getDetailCampaignReducer,
  evaluateCVReducer,
  getDetailEvaluationReducer,
  filterEventsReducer,
  formDetailInterviewReducer,
  getDetailInterviewReducer,
  confirmParticipateReducer,
  updateResultPanelReducer,
  getListProgramReducer,
});

export default recruitmentReducer;
